import { render, staticRenderFns } from "./AiChangePromptEffect.vue?vue&type=template&id=1816c663&scoped=true&"
import script from "./AiChangePromptEffect.vue?vue&type=script&lang=js&"
export * from "./AiChangePromptEffect.vue?vue&type=script&lang=js&"
import style0 from "./AiChangePromptEffect.vue?vue&type=style&index=0&id=1816c663&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1816c663",
  null
  
)

export default component.exports